import { Pipe, PipeTransform, inject } from '@angular/core';
import { DeviceType } from '../../../shared/models/generated/ziroModels';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'publicDevice',
  standalone: false,
})
export class PublicDevicePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(owner: string, deviceType: string): string {
    return owner || (deviceType === DeviceType.DESK_PHONE ? this.translate.instant('tkey;pages.phone.title') : '');
  }
}
